import PartnerSubmittalDetails from "./feature-model-pages/partner-submittal-details";

function PartnerSubmittalDetailsLandingPage() {
  return <PartnerSubmittalDetails />;
}

export default PartnerSubmittalDetailsLandingPage;
